<template>
  <MainLayout
    bg-color="background-normal"
    no-content-padding
    aditional-classes="relative"
  >
    <template #toolbar>
      <div class="flex items-center justify-between px-5 py-3.5">
        <div class="flex items-center">
          <img
            src="../../assets/images/dashboard-icon.png"
            class="w-10 h-10 ring-1 ring-offset-1 rounded-lg ring-neutral-100 shadow-lg"
          >
          <div class="ml-3">
            <BaseText
              type="label"
              size="md"
              class="text-neutral-900 font-medium"
            >
              Dashboard
            </BaseText>

            <BaseText
              type="body"
              size="sm"
              class="text-text-normal w-52 overflow-visible whitespace-nowrap"
            >
              Your Creative Strategy Hub
            </BaseText>
          </div>
        </div>
      </div>
    </template>
    <template #content>
      <div class="flex flex-col items-center justify-center mx-auto max-w-7xl">
        <!-- <BaseCardTransition>
          <BFCMCard />
        </BaseCardTransition> -->
        <BaseCardTransition>
          <AccountCard />
        </BaseCardTransition>
        <BaseCardTransition>
          <ReferralCard />
        </BaseCardTransition>
        <BaseCardTransition>
          <ExtentionCard />
        </BaseCardTransition>
        <!-- <BaseCardTransition>
          <CourseCard />
        </BaseCardTransition> -->
        <BaseCardTransition>
          <TutorialCard />
        </BaseCardTransition>
        <BaseCardTransition>
          <SwipeFileCard />
        </BaseCardTransition>
        <BaseCardTransition>
          <DiscoveryCard />
        </BaseCardTransition>
        <BaseCardTransition>
          <BriefsCard />
        </BaseCardTransition>
        <BaseCardTransition>
          <BottomCards />
        </BaseCardTransition>
      </div>
    </template>
  </MainLayout>
</template>
<script>
import AccountCard from '../../components/dashboard/AccountCard.vue'
// import BFCMCard from '../../components/dashboard/BFCMCard.vue'
import BottomCards from '../../components/dashboard/BottomCards.vue'
import BriefsCard from '../../components/dashboard/BriefsCard.vue'
import ReferralCard from '../../components/dashboard/ReferralCard.vue'
import CourseCard from '../../components/dashboard/CourseCard.vue'
import DiscoveryCard from '../../components/dashboard/DiscoveryCard.vue'
import ExtentionCard from '../../components/dashboard/ExtentionCard.vue'
import IntegrationsCard from '../../components/dashboard/IntegrationsCard.vue'
import MainLayout from '@/layouts/MainLayout.vue'
import SwipeFileCard from '../../components/dashboard/SwipeFileCard.vue'
import TutorialCard from '../../components/dashboard/TutorialCard.vue'
import InstagramModal from '../../components/dashboard/Modals/InstagramModal.vue'
import { mapGetters } from 'vuex'
import FirebaseAPI from '@/api/firebase'

export default {
  name: 'DashboardView',
  components: {
    AccountCard,
    // BFCMCard,
    BottomCards,
    BriefsCard,
    CourseCard,
    DiscoveryCard,
    ExtentionCard,
    IntegrationsCard,
    ReferralCard,
    MainLayout,
    SwipeFileCard,
    TutorialCard,
    InstagramModal
  },
  data () {
    return {
      shoWrapped: false,
      hideInstagramModal: true,
      team: null
    }
  },
  metaInfo: {
    title: 'Foreplay.co | Dashboard'
  },
  computed: {
    ...mapGetters('AuthModule', ['getTeam', 'getUser'])
  },
  async mounted () {
    if (window.location.hash === '#instagram') {
      this.hideInstagramModal = false
    }
  },
  methods: {
    scrollToInstagramConnect () {
      const el = document.getElementById('integrations-card')
      el.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>
<style scoped></style>
